// extracted by mini-css-extract-plugin
export default {"announcement":"announcement--SedDH","announcement-label":"announcement-label--t9DwJ","announcement-content":"announcement-content--jtttS"};